module.exports = __webpack_public_path__ + "static/media/piggy_bank.06b70950.svg";